var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import './index.scss';
import classnames from 'classnames';
import { arrayOf, bool, node, oneOfType, string } from 'prop-types';
import React, { forwardRef } from 'react';
const IconInput = ({ lefticon, righticon, children }) => {
    IconInput.propTypes = {
        lefticon: node,
        righticon: node,
        children: oneOfType([arrayOf(node), node]),
    };
    const inputClass = classnames('input-container', {
        'has-left-icon': lefticon,
        'has-right-icon': righticon,
    });
    if (!lefticon && !righticon) {
        return React.createElement("span", { className: inputClass }, children);
    }
    return (React.createElement("span", { className: inputClass },
        lefticon && React.createElement("span", { className: 'left-icon' }, lefticon),
        children,
        righticon && React.createElement("span", { className: 'right-icon' }, righticon)));
};
const Input = forwardRef((_a, ref) => {
    var { type, children, large, small, className, lefticon, righticon } = _a, rest = __rest(_a, ["type", "children", "large", "small", "className", "lefticon", "righticon"]);
    Input.propTypes = {
        type: string,
        lefticon: node,
        righticon: node,
        large: bool,
        small: bool,
        className: string,
        children: oneOfType([arrayOf(node), node]),
    };
    const inputClass = classnames('input', className, {
        checkbox: type === 'checkbox',
        radio: type === 'radio',
        select: type === 'select',
        small: small,
        large: large,
        success: rest.success,
        error: rest.error,
    });
    if (type === 'select') {
        let placeholderOption = null;
        if (rest.placeholder) {
            placeholderOption = (React.createElement("option", { disabled: true, value: '', selected: true }, rest.placeholder));
        }
        return (React.createElement(IconInput, { lefticon: lefticon, righticon: righticon },
            React.createElement("select", Object.assign({ required: true, className: inputClass, ref: ref }, rest),
                placeholderOption,
                children)));
    }
    if (type === 'radio') {
        const labelClass = classnames('input-label', {
            disabled: rest.disabled,
        });
        return (React.createElement(IconInput, { lefticon: lefticon, righticon: righticon },
            React.createElement("input", Object.assign({ type: 'radio', className: inputClass, ref: ref }, rest)),
            React.createElement("label", { className: labelClass, htmlFor: rest.id }, rest.label)));
    }
    if (type === 'checkbox') {
        const labelClass = classnames('input-label', {
            disabled: rest.disabled,
        });
        return (React.createElement(IconInput, { lefticon: lefticon, righticon: righticon },
            React.createElement("input", Object.assign({ type: 'checkbox', className: inputClass, ref: ref }, rest)),
            React.createElement("label", { className: labelClass, htmlFor: rest.id }, rest.label)));
    }
    if (type === 'textarea') {
        return (React.createElement(IconInput, { lefticon: lefticon, righticon: righticon },
            React.createElement("textarea", Object.assign({ className: inputClass, ref: ref }, rest), children)));
    }
    return (React.createElement(IconInput, { lefticon: lefticon, righticon: righticon },
        React.createElement("input", Object.assign({ className: inputClass, ref: ref }, rest))));
});
export default Input;
